import { WalletTransactionType } from "@/api/transactions"
import { cn } from "@/lib/utils"
import ArrowDownIcon from "@/components/icons/arrow-down"

const optionsByType: {
  [key in WalletTransactionType]: {
    bg: string;
    color: string;
    icon: "up" | "down";
  };
} = {
  [WalletTransactionType.PAYMENT_RECEIVED]: {
    bg: "bg-green-50",
    color: "text-green-500",
    icon: "down",
  },
  [WalletTransactionType.PAYMENT_SENT]: {
    bg: "bg-red-50",
    color: "text-red-500",
    icon: "up",
  },
  [WalletTransactionType.WITHDRAWAL]: {
    bg: "bg-red-50",
    color: "text-red-500",
    icon: "up",
  },
}

export default function PaymentTypeIcon({
  type,
}: {
  type: WalletTransactionType;
}) {
  return (
    <div
      className={cn(
        "flex flex-row p-1 w-8 h-8 items-center justify-center  rounded-full",
        optionsByType[type].bg,
      )}
    >
      <div className={optionsByType[type].color}>
        <ArrowDownIcon direction={optionsByType[type].icon} size={15} />
      </div>
    </div>
  )
}
